/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateTaskItemQaEquipmentSetupDto } from './CreateTaskItemQaEquipmentSetupDto';
import {
    instanceOfCreateTaskItemQaEquipmentSetupDto,
    CreateTaskItemQaEquipmentSetupDtoFromJSON,
    CreateTaskItemQaEquipmentSetupDtoFromJSONTyped,
    CreateTaskItemQaEquipmentSetupDtoToJSON,
} from './CreateTaskItemQaEquipmentSetupDto';

/**
 * @type GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup
 * 
 * @export
 */
export type GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup = CreateTaskItemQaEquipmentSetupDto;


export function GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSON(json: any): GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup {
    return GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSONTyped(json, false);
}

export function GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateTaskItemQaEquipmentSetupDtoFromJSONTyped(json, true) };
    return  CreateTaskItemQaEquipmentSetupDtoFromJSONTyped(json, true);
}

export function GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetupToJSON(value?: GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateTaskItemQaEquipmentSetupDto(value)) {
        return CreateTaskItemQaEquipmentSetupDtoToJSON(value as CreateTaskItemQaEquipmentSetupDto);
    }

    return {};
}

/**
 * Check if a given object implements the GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup interface.
 */
export function instanceOfGetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup(value: any): value is GetQaEquipmentSetupTemplateDtoPreviousQaEquipmentSetup {
    if (instanceOfCreateTaskItemQaEquipmentSetupDto(value)) return true;
    return false;
}

